<bricks-icon
  color="primary"
  height="24px"
  width="24px"
  [matTooltip]="text()"
  matTooltipPosition="right"
  matTooltipClass="tooltip-info-outline">
  bricks-info-filled
</bricks-icon>
